module.exports = __webpack_public_path__ + "img/logo-twas.4b12dc82.png";